import styled from 'styled-components'
import { headerHeight, headerMargin } from '../constants'
import image from '../../images/404.gif'

export const Image = styled.img.attrs({ src: image })`
    max-width: 480px;
`

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: calc(100vh - ${headerHeight + headerMargin}px);
`
